import React from 'react';
import { CareersPage, type CareersPageProps } from '../../components/CareersPage';
import { BIProvider, PAGE_NAMES } from '../../bi';

const App = ({ comeetPositions = [], ...props }: CareersPageProps) => (
    <BIProvider pageName={PAGE_NAMES.main}>
        <CareersPage comeetPositions={comeetPositions} {...props} />
    </BIProvider>
);

export default App;
